/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';

export default (props: {
  'data-testid'?: string,
  emailBody: string,
  message: string,
}): Element<string> => (
  <div
    className="card"
    css={css('border: none;')}
    data-testid={props['data-testid'] || 'UpgradeCard'}
  >
    <div className="card-body" css={css('max-width: 330px;')}>
      <p className="mb-2 text-left">{props.message}</p>
    </div>
    <div className="d-flex border-top pt-3">
      <a
        href={`mailto:star@citiesense.com?subject=Upgrade&body=${
          props.emailBody
        }`}
        className="btn btn-primary rounded"
        tabIndex={0}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="UpgradeButton"
      >
        Upgrade
      </a>
    </div>
  </div>
);
